
import React from 'react';
import L from 'leaflet';
import { connect } from 'react-redux';
import { RootState } from 'typesafe-actions';
import { Marker } from 'react-leaflet';
import pathDot from '../../assets/images/ship_path_dot.svg';
import { Position } from '../../services/types';
import { longitudeOffsets } from '../LeafletMap';

const pathDotIcon = new L.Icon({
  iconUrl: pathDot,
  iconSize: [8, 8]
});

export const PostionMarkers: React.FC<PostionMarkersProps> = ({ selectedVoyagePostitions, dotFrequency }) => {
  if (!selectedVoyagePostitions || !selectedVoyagePostitions[0]) {
    return null;
  }

  return (
    <div>
      {selectedVoyagePostitions
        .filter((_, index) => index % dotFrequency === 0)
        .map((position: Position) => (
          <div key={position.id}>
            {longitudeOffsets.map((longOffset, index) => (
              <Marker
                key={"position" + position.timestamp + index}
                keyboard={false}
                position={[
                  position.lat,
                  position.long + longOffset
                ]}
                icon={pathDotIcon}
                riseOnHover={true}
              />
            ))}
          </div>
        ))}
    </div>
  );
};

const mapStateToProps = (state: RootState, ownProps: { dotFrequency: number }) => ({
  selectedVoyagePostitions: state.voyagesData.selectedVoyagePostitions,
  dotFrequency: ownProps.dotFrequency
});

const dispatchProps = {};

type PostionMarkersProps = ReturnType<typeof mapStateToProps> & typeof dispatchProps;

export default connect(
  mapStateToProps,
  dispatchProps
)(PostionMarkers);